import {ThreeDots} from 'react-loader-spinner';

const  Spinner = ({ isloading, color, h, w}) => {
      return  (<ThreeDots
                height={h}
                width={w}
                radius="9"
                color={color}
                ariaLabel="three-dots-loading"
                wrapperStyle={{ margin: '2px' }}
                wrapperClass="custom-loader"
                visible={isloading}
         />)
     };

 
export default Spinner;